import { useQuery } from 'react-query';
import { auth0UserService } from 'services';
import { ServerStateKeysEnum } from '../constants';
import { useLoggedInUserTypeStore } from 'store/loggedInUserTypeStore';

export const useAuth0UserInfo = () => {
  const setLoggedInUserType = useLoggedInUserTypeStore(
    state => state.setUserType
  );
  return useQuery(
    ServerStateKeysEnum.auth0UserInfo,
    () => {
      return auth0UserService.getAuth0UserInfo();
    },
    {
      staleTime: Infinity,
      refetchOnWindowFocus: false,
      onSuccess: data => {
        if (data?.business_unit) {
          setLoggedInUserType(data.business_unit);
        }
      },
    }
  );
};
